export default "__VITE_ASSET__Doztwovb__"